import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id B2D19D07-ACC6-462B-BD11-50CC805E104B
 * name home-floor-g
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-g.svg
 * tags
 * - Home Automation 
 */
export const HomeFloorGIcon = createSvgIcon(<><path d="M12,3L2,12H5V20H19V12H22L12,3M11,8H15V10H11V16H13V12H15V16C15,17.11 14.1,18 13,18H11A2,2 0 0,1 9,16V10C9,8.89 9.9,8 11,8Z" /></>, 'HomeFloorGIcon');
export default HomeFloorGIcon